import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { UnitContextMenuView, ContextMenuResource } from '@mark43/cad-api';
import { useApiClient } from '~/api-client';

export function useUnitContextMenuQuery({
    unitId,
    enabled = true,
}: {
    unitId: number;
    enabled?: boolean;
}): UseQueryResult<UnitContextMenuView> {
    const apiClient = useApiClient();
    return useQuery(
        ['unitContextMenuView', unitId],
        () => {
            return apiClient
                .request<ContextMenuResource.GetUnitContextMenu>({
                    method: 'POST',
                    url: `context_menu/unit/${unitId}/`,
                    data: { unitStateTransitionPermission: 'DISPATCHER' },
                })
                .then((response) => {
                    return response.data.data;
                });
        },
        { enabled }
    );
}
